import React from "react";

export const GrowthAreaFocus = () => {
  // Sample data for growth areas
  const growthAreas = [
    {
      subject: "Maths: Fraction Operations",
      feedback:
        "You're doing great with addition fraction, but division needs more practice.",
      percentComplete: 40,
    },
    {
      subject: "Biology: Plant Life Cycle",
      feedback:
        "You're having trouble with photosynthesis. Let's work on this.",
      percentComplete: 40,
    },
  ];

  return (
    <div className="mt-6">
      <h1 className="text-2xl font-bold mb-2">Grow Smarter!</h1>
      <p className="text-gray-600 mb-6">
        Based on your recent performance, here's where you can improve the most.
      </p>

      {growthAreas.map((area, index) => (
        <div key={index} className="bg-white rounded-xl shadow-md p-6 mb-4">
          <div className="flex justify-between items-start mb-3">
            <div>
              <h2 className="font-semibold text-gray-800">{area.subject}</h2>
              <p className="text-sm text-gray-600">{area.feedback}</p>
            </div>
            <button className="bg-purple-500 hover:bg-purple-600 text-white text-sm font-medium py-2 px-4 rounded-full">
              Level Up
            </button>
          </div>

          <div className="relative pt-1">
            <div className="flex mb-2 items-center justify-between">
              <div>
                <span className="text-xs font-semibold inline-block py-1 px-2 rounded-full bg-orange-200 text-orange-600">
                  {area.percentComplete}% Complete
                </span>
              </div>
            </div>
            <div className="overflow-hidden h-2 text-xs flex rounded-full bg-gray-200">
              <div
                style={{ width: `${area.percentComplete}%` }}
                className="shadow-none flex flex-col text-center whitespace-nowrap text-white justify-center bg-orange-500 rounded-full"
              ></div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default GrowthAreaFocus;
